
<template>
    <div class="l-content__block"  v-show="showHistory">
        <div class="c-block__headings">
            <h2 class="">おすすめモデル</h2>
            <div v-show="this.show_more" class="c-btn-detail">
                <a :href="route(route_list, 'site.talent.index')" :id="this.show_more_id_pc">もっと見る</a>
            </div>
        </div>
        <div class="c-slider-model-wrapper">
            <div class="c-slider-model swiper-container-recommend-talents">
                <img src="/src/assets/img/common/slider-arrow-prev.png" alt="＜" class="slide-arrow prev-arrow">
                <div class="swiper-wrapper">
                    <div class="c-slider-model__item swiper-slide" v-for="talent in talents">
                        <a :href="talent.url">
                            <div class="c-slider-model__img">
                                <webp-picture :webp="talent.thumb_nail_webp">
                                    <img loading="lazy" :src="talent.thumb_nail" alt="">
                                </webp-picture>
                            </div>
                            <p class="c-slider-model__name">{{ talent.title }}</p>
                        </a>
                    </div>
                </div>
                <img src="/src/assets/img/common/slider-arrow-next.png" alt="＞" class="slide-arrow next-arrow">
            </div>
        </div>
        <div v-show="this.show_more" class="c-btn-detail is-sp">
            <a :href="route(route_list, 'site.talent.index')" :id="this.show_more_id_sp">もっと見る</a>
        </div>
    </div>
</template>

<script>
import routeMixin from '../../mixins/route.js';
import axios from 'axios';
export default {
    props: {
        route_list: Object,
        recommend_categories: Array,
        recommend_from : String,
        recommender_string: String,
        number_of_result: String,
        show_more: Boolean,
        show_more_id_pc: String,
        show_more_id_sp: String,
        limit: String,
    },
    mixins: [routeMixin],
    data() {
        return {
            talents: [],
        }
    },
    methods: {
        getData: async function(){
            let url = this.route(this.route_list, 'site.api.recommender');;
            let talents = [];
            let params = {
                params: {
                    recommend_from : this.recommend_from,
                    recommender_string : this.recommender_string,
                    number_of_result : this.number_of_result,
                    recommend_categories : this.recommend_categories,
                    limit: this.limit,
                }
            }
            let fall_back_param = {
                params: {
                    recommender_string : 'mostviewed',
                    number_of_result : this.number_of_result,
                    recommend_categories : this.recommend_categories,
                    limit: this.limit,
                }
            }
            if (!this.recommend_from) {
                params = fall_back_param
            }

            let done = false;
            await axios.get(url, params)
            .then(res => {
                talents = res.data;
                done = true;
            }).catch(error => {

            });

            if (done && talents.length === 0) {
                await axios.get(url, fall_back_param
                ).then(res => {
                    talents = res.data;
                }).catch(error => {

                });
            }

            return talents;
        },
        makeData: async function(){
            let talents = await this.getData();
            // 加工があれば追記
            this.talents = talents.slice(0,5);
        },
        runSwiper: function() {
            // Swiperの初期化
            if (this.swiperInstance) {
                this.swiperInstance.destroy(true, true);
            }
            this.$nextTick(() => {
                this.swiperInstance = new Swiper('.swiper-container-recommend-talents', {
                    slidesPerView: 3.2,
                    slidesPerGroup: 1,
                    spaceBetween: 0,
                    loop: false,
                    navigation: {
                        nextEl: '.next-arrow',
                        prevEl: '.prev-arrow',
                    },
                    breakpoints: {
                        767: {
                            slidesPerView: 5,
                            slidesPerGroup: 2,
                            spaceBetween: 25,
                        }
                    },
                });
            });
        },
    },
    computed: {
        showHistory: function() {
            return this.talents.length > 0;
        }
    },
    async mounted() {
        await this.makeData();
        this.runSwiper();
    }
}
</script>

<style lang="scss" scoped>
    .swiper-container-recommend-talents {
        margin-left: auto;
        margin-right: auto;
        position: relative;
        overflow: hidden;
        list-style: none;
        z-index: 1;
    }

    .c-slider-model__name {
        line-height: 1em;
    }

    @media screen and (min-width: 768px) {
        .swiper-slide {
            padding: 0px;
        }

        .c-slider-model__item {
            margin: 0px;
        }
    }
</style>
